import { DecimalPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input, OnInit } from '@angular/core'
import { getKpiColor } from '@shared/utils/colors'

export interface CircularProgress {
  id: string
  title?: string
  current: number | string
  goal: number | string
  isShortly?: boolean
}

@Component({
  selector: 'circular-progress',
  imports: [DecimalPipe],
  standalone: true,
  templateUrl: './circular-progress.component.html',
  styleUrl: './circular-progress.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CircularProgressComponent implements OnInit {
  percentage = input<number>(0)

  color = computed(() => getKpiColor(this.percentage()))

  strokeDashoffsetVal = 0
  circumference = 326

  ngOnInit(): void {
    this.setShadowColor()
  }

  setShadowColor(): void {
    document.documentElement.style.setProperty('--progress-shadow-color', this.color())
  }

  get strokeDashoffset(): number {
    const radius = 45
    const circumference = 2 * Math.PI * radius

    const per = this.percentage() > 100 ? 100 : this.percentage()
    return circumference - (per / 100) * circumference
  }
}
